module.exports = __webpack_public_path__ + "static/img/start.894f1842.svg";